module.exports = __webpack_public_path__ + "img/multiple-play-icon.ad4e6295.svg";